import React, { ReactNode } from 'react';

import AlertMaterial, { AlertProps as AlertMaterialProps } from '@mui/material/Alert';
import AlertTitleMaterial from '@mui/material/AlertTitle';
import classNames from 'classnames/bind';

import { IconType, SvgIcon } from '@components/SvgIcon';

import styles from './Alert.module.css';

export type AlertProps = {
  type: 'success' | 'error' | 'info' | 'warning' | 'impersonate' | 'alert';
  title?: string;
  action?: ReactNode;
  titleClassName?: string;
  messageClassName?: string;
  bodyClassName?: string;
  actionClassName?: string;
  iconClassName?: string;
  noIcon?: boolean;
  size?: 'small' | 'medium';
  icon?: ReactNode;
} & Pick<AlertMaterialProps, 'children' | 'variant' | 'className'>;

const cn = classNames.bind(styles);

export const ALERT_ICON_MAP = {
  alert: 'alarm',
  success: 'alertSuccess',
  error: 'alertError',
  info: 'alertError',
  warning: 'alertError',
  impersonate: 'adminCircle',
};

export function Alert({
  title,
  action,
  children,
  className,
  variant = 'outlined',
  type,
  icon,
  titleClassName,
  messageClassName,
  bodyClassName,
  actionClassName,
  iconClassName,
  noIcon,
  size,
}: AlertProps) {
  const ICON = icon || (
    <SvgIcon className={cn('alert__icon', `alert__icon--${type}`)} icon={ALERT_ICON_MAP[type] as IconType} />
  );

  return (
    <AlertMaterial
      className={cn('alert', `alert--${type}`, className, {
        [`alert--${size}`]: size,
      })}
      icon={noIcon ? false : ICON}
      variant={variant}
      classes={{
        message: cn('alert__message', messageClassName, {
          [`alert__message--${size}`]: size,
        }),
        icon: cn(iconClassName, 'alert__icon', {
          [`alert__icon--${type}`]: type && !icon,
          [`alert__icon--${size}`]: size,
        }),
      }}
    >
      <div className={cn('alert__body', bodyClassName)}>
        <div>
          {!!title && <AlertTitleMaterial className={cn('alert__title', titleClassName)}>{title}</AlertTitleMaterial>}

          {children}
        </div>

        {!!action && <div className={actionClassName}>{action}</div>}
      </div>
    </AlertMaterial>
  );
}
